import { render } from "./transaksi-epod.vue?vue&type=template&id=400a2e7c"
import script from "./transaksi-epod.vue?vue&type=script&lang=js"
export * from "./transaksi-epod.vue?vue&type=script&lang=js"
script.render = render

export default script